export default function Safety() {
  return (
    <section id="seguranca" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
              Segurança e Confiança
            </span>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Hoobuy é<br />
              Seguro?<br />
              <span className="text-accent-600">Proteção Garantida</span>
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              Sim, a Hoobuy oferece um sistema completo de proteção ao comprador. Você conta com inspeção de produtos antes do envio, diversas opções de pagamento seguro e suporte ao cliente disponível 24 horas por dia. Milhares de compradores no Brasil e Portugal já utilizam a plataforma com confiança.
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              {['Inspeção de Produtos', 'Proteção ao Comprador', 'Pagamento Seguro', 'Suporte 24h'].map((item) => (
                <span key={item} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-50 text-xs font-medium text-accent-700 border border-accent-200/60">
                  <i className="ri-shield-check-line"></i>
                  {item}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="rounded-lg overflow-hidden bg-accent-600 p-6 md:p-8 relative">
              <div className="absolute top-6 right-6 flex gap-1.5">
                <span className="w-2 h-2 rounded-full bg-white/40"></span>
                <span className="w-2 h-2 rounded-full bg-white/40"></span>
                <span className="w-2 h-2 rounded-full bg-white/40"></span>
              </div>
              <span className="text-xs text-white/50 font-medium uppercase tracking-wider">Depoimento</span>
              <blockquote className="mt-4 text-base md:text-lg text-white leading-relaxed">
                "Depois de testar vários agentes chineses, a Hoobuy foi a que mais me passou segurança. O sistema de inspeção com fotos reais antes do envio faz toda a diferença. Recomendo para qualquer pessoa que queira comprar com tranquilidade."
              </blockquote>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  <span className="text-white font-semibold text-sm">MC</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-white">Maria C.</p>
                  <p className="text-xs text-white/50">São Paulo, Brasil</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}